// extracted by mini-css-extract-plugin
export var footer = "_qf-0";
export var inherit = "_qf-1";
export var input = "_qf-2";
export var modalContent = "_qf-3";
export var quillEditor = "_qf-4";
export var subtitle = "_qf-5";